<ng-container *transloco="let t; prefix: ''">
  @if (accessDenied$ | async; as reason) {
    <div class="access-denied">
      <h2>{{ t('access.deniedTitle') }}</h2>
      @if (reason === 'wrong-organization') {
        <p>{{ t('access.wrongOrganization', { tenant: tenantAlias }) }}</p>
      } @else if (reason === 'missing-role') {
        <p>{{ t('access.missingRole', { tenant: tenantAlias }) }}</p>
      } @else {
        <p>{{ t('access.generic') }}</p>
      }
      <button mat-flat-button color="primary" (click)="logout()">
        {{ t('menu.logout') }}
      </button>
    </div>
  } @else {
    <mat-toolbar class="toolbar">
      <div class="headline-box">
        <img class="ht-x-logo" src="assets/images/ht-x-logo.png" alt="Main-Logo" routerLink="/" />
        <h1>{{ t('menu.headerTitle') }}</h1>
      </div>
      <mat-nav-list class="routes-nav-box">
        @for (item of routeList; track item) {
          <a routerLink="{{ item.link }}" routerLinkActive="active-route">
            <div
              class="route-item"
              [routerLink]="item.link"
              routerLinkActive
              #rla="routerLinkActive"
            >
              <img
                class="icon"
                [src]="rla.isActive ? item.activeIcon : item.icon"
                alt="Navigation-Icon"
              />
              <span>{{ t(item.nameKey) }}</span>
            </div>
          </a>
        }
      </mat-nav-list>
      <button class="settings-button">
        <img
          src="assets/images/settings-icon.svg"
          [matMenuTriggerFor]="profileMenu"
          alt="Settings"
        />
      </button>
      <mat-menu #profileMenu="matMenu">
        <div class="language-switch">
          <span class="lang-label-DE">DE</span>
          <mat-slide-toggle
            [checked]="isEnglish"
            (change)="onToggleLanguage($event.checked)"
            (click)="$event.stopPropagation()"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation()"
            aria-label="Language switch"
          ></mat-slide-toggle>
          <span class="lang-label-EN">EN</span>
        </div>
        <div class="connector-role">
          <span>{{ environment.role }}</span>
          <span>{{ t('menu.connectorRole') }}</span>
        </div>
        <div>
          <span>{{ username }}</span>
        </div>
        <button id="logoutButton" class="mat-button mat-primary" mat-flat-button (click)="logout()">
          {{ 'menu.logout' | transloco }}
        </button>
      </mat-menu>
    </mat-toolbar>
    <div class="component-container">
      <router-outlet></router-outlet>
    </div>
    <app-slide-over-panel />
  }
</ng-container>
